<template lang="pug">
  .single-select
    SearchBar(:value="value" @input="val => $emit('input', val)" :show-label="false")
    .filter-panel
      .filter-item(
        v-for="entry of filteredEntries"
        @click="clicked(entry)"
      ) {{ entry }}
</template>

<script>
import SearchBar from '@/components/SearchBar'

export default {
  name: 'SingleSelect',
  props: {
    value: {
      type: String,
      default: '',
    },
    entries: {
      type: Array,
      default: () => {},
    },
  },
  methods: {
    clicked: function(value) {
      this.$emit('input', value)
      this.$emit('clicked')
    },
  },
  computed: {
    filteredEntries: function() {
      return this.entries.filter(entry =>
        entry
          .toString()
          .toLowerCase()
          .includes(this.value.toLowerCase()),
      )
    },
  },
  components: {
    SearchBar,
  },
}
</script>

<style lang="scss" scoped>
.single-select {
  min-width: 20rem;
  width: fit-content;
}

.filter-panel {
  max-height: 10rem;
  background-color: white;
  border: 1px solid #e6e6e6;
  overflow-y: auto;
}

.filter-item {
  padding: 0.5rem 1rem;
  border-bottom: 1px solid #e6e6e6;
}

.filter-item:hover {
  background-color: #7c3a74;
  color: white;
  cursor: pointer;
}
</style>
